import { Component, OnInit, OnDestroy, ViewChild, HostListener, AfterViewInit, ViewChildren } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as Chart from 'chart.js';
import { IssueService } from '../../../../services/issue.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { getQueryParamFromAncestorRoute } from '../../../../utilities/route.utilities';

@Component({
    selector: 'issues-latest-bill-estimated-chart',
    template: '<canvas id="basechart"  #basechart *ngIf="data.length; else noData"></canvas><ng-template #noData><p class="text-center">No data available</p></ng-template>',
    styles: [`:host { width: 100%; position: relative; display:block; }`]

})
export class IssuesLatestBillEstimatedChartComponent implements AfterViewInit, OnDestroy {

    @ViewChildren('basechart') basechart: any;
    chart: any;
    subscriptions: any[] = [];
    debounceTimeout = 2000;
    debounceId: any;
    consumerId: string;
    polarAreaData: any;
    clientId: number;
    dataNotBeyondEmergency: any[] = [];
    dataNotUsingOverCredit: any[] = [];
    dataUsingOverCredit: any[] = [];
    data: any[] = [];
    labels: any[] = [];
    pipe: DatePipe = new DatePipe('en_GB');
    siteId: number;


    constructor(private issueService: IssueService,
        private route: ActivatedRoute,
        private router: Router) {
    }

    ngAfterViewInit(): void {
        this.route.queryParams.subscribe(queryParams => {
            this.onInitialise();
        });
    }

    onInitialise() {
        this.clientId = this.route.parent.snapshot.params['clientId'];
        if (this.clientId == null || this.clientId == undefined) this.clientId = this.route.parent.parent.snapshot.params['clientId'];

        this.siteId = getQueryParamFromAncestorRoute(this.route, 'siteId');


        this.issueService.getBillingLatestBillEstimatedSummary(this.clientId, this.siteId).then((result) => {
            let resultData = result as any;

            this.data = [];
            this.labels = [];
            if (result) {
                if (resultData.actual > 0) { this.data.push(resultData.actual); this.labels.push('Actual readings'); }
                if (resultData.estimated > 0) { this.data.push(resultData.estimated); this.labels.push('Estimated readings');}
            }
            this.createChart();
        });

    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
        if (this.debounceId) {
            clearTimeout(this.debounceId);
        }
    }

    private getChartConfig(): any {
        let config = {
            type: 'doughnut',
            options: {
                tooltips: {
                    mode: 'index',
                    enabled: true,
                    backgroundColor: '#ffffff',
                    titleFontColor: '#153954',
                    bodyFontColor: '#153954',
                    borderWidth: 2,
                    borderColor: '#009aa3'
                },
                maintainAspectRatio: true,
                legend: {
                    display: true
                },
                scales: {
                    xAxes: [{
                        display: false,
                        stacked: true,
                        scaleLabel: {
                            display: false,
                            labelString: 'Amount Days',
                            fontSize: 15,
                        },
                        position: 'right',
                    }],
                    yAxes: [
                        {
                            display: false,
                            id: "y-axis-0",
                            stacked: true,
                            scaleLabel: {
                                display: false,
                                labelString: 'Amount',
                                fontSize: 15,
                                fontStyle: "bold",
                            },
                            position: 'right',
                        },
                    ]

                }
            }
        }

        return config;
    }

    @HostListener('window:resize', ['$event'])
    onResize(event: any) {
        this.createChart();
    }

    createChart() {
        if (this.chart != null) this.chart.destroy();
        if (!this.basechart) return;

        let datasets = [] as any;

        datasets.push({
            data: this.data,
            backgroundColor: ['#93c01f', '#c82b2b'],
            pointRadius: 3,
            borderWidth: 2,
            pointHoverRadius: 8,
            pointHitRadius: 10,
            borderColor: ['#93c01f', '#c82b2b'],
            pointBorderColor: ['#93c01f', '#c82b2b'],
            pointBackgroundColor: ['#93c01f', '#c82b2b'],
            pointHoverBackgroundColor: ['#93c01f', '#c82b2b'],
            pointHoverBorderColor: ['#93c01f', '#c82b2b'],
        });

        let config = this.getChartConfig();
        let chartConfiguration: Chart.ChartConfiguration = {
            type: config.type,
            options: config.options,
            data: {
                datasets: datasets,
                labels: this.labels
            }
        };



        if (this.debounceId) {
            window.clearTimeout(this.debounceId);
        };

        this.debounceId = window.setTimeout(() => {
            if (this.chart != null) this.chart.destroy();
            if (!this.basechart || !this.basechart.first) return;
            let ctx = this.basechart.first.nativeElement;
            this.chart = new Chart(ctx, chartConfiguration);
        }, this.debounceTimeout);
    }


}
